import React, { ChangeEvent } from "react";
import searchIcon from "../../assets/icons/search_icon.svg";
import menuIcon from "../../assets/icons/menu_icon.svg";
import crossIcon from "../../assets/icons/cross_icon.svg";
import { CONSTANTS } from "../../constants/Constants";
import Input from "../Inputs";
import Select from "../Select";

interface SearchBarMenuProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  filtersHandler: (filterQuery: string, filterName: string) => void;
  filters: { query: string; title: string; status: string };
  filtersDropDown: { id: string; name: string }[]
}

const SearchBarAndMenu: React.FC<SearchBarMenuProps> = ({
  isMenuOpen,
  toggleMenu,
  filtersHandler,
  filters,
  filtersDropDown
}) => {
  return (
    <div className="flex justify-between items-center gap-2 h-16 w-full">
      {/* Search Bar */}
      <div
        className={`w-full border border-gray-300 rounded-3xl overflow-hidden px-3 flex ${isMenuOpen ? "hidden" : "flex"
          }`}
      >
        <img src={searchIcon} alt="search_icon" className="mr-3" width={14} />
        <Input
          input_name={CONSTANTS.SEARCH_TXT}
          placeholder={CONSTANTS.SEARCH_TXT}
          type="text"
          other_classes="px-0 w-full text-sm border-none !focus:outline-none"
          value={filters.query}
          change_handler={(e: ChangeEvent<HTMLInputElement>) =>
            filtersHandler(e.target.value, "query")
          }
        />
      </div>

      {/* Menu Section */}
      <div
        className={`flex font-medium gap-2  text-[13px] items-center
          ${isMenuOpen ? "flex w-[85%] overflow-x-auto" : "hidden md:flex"}`}
      >
        <div className="w-28 relative inline-block">
          <Select
            key={"01"}
            name={CONSTANTS.SELECT_CATERGORY}
            options={filtersDropDown}
            handle_change={(e: ChangeEvent<HTMLSelectElement>) =>
              filtersHandler(e.target.value, CONSTANTS.TITLE_TXT.toLocaleLowerCase())
            }
            firstOptionText={CONSTANTS.TITLE_TXT}
          />
        </div>
        <div className="w-28 relative inline-block">
          <Select
            key={"01"}
            name={CONSTANTS.SELECT_EXPERIENCE}
            options={[{ id: "1,3", name: "1 to 3 years" }, { id: "3,5", name: "3 to 5 years" }, { id: "5,7", name: "5 to 7 years" }, { id: "7,50", name: "7+ years" },]}
            handle_change={(e: ChangeEvent<HTMLSelectElement>) => filtersHandler(e.target.value, CONSTANTS.EXPERIENCE_TXT.toLocaleLowerCase())}
            firstOptionText={CONSTANTS.EXPERIENCE_TXT}
          />
        </div>
        <div className="w-28 relative inline-block">
          <Select
            key={"01"}
            name={CONSTANTS.SELECT_STATUS}
            options={[{ value: CONSTANTS.PUBLISHED_TXT, name: CONSTANTS.PUBLISHED_TXT }, { value: CONSTANTS.DRAFT_TXT, name: CONSTANTS.DRAFT_TXT }, { value: CONSTANTS.DISABLED_TXT, name: CONSTANTS.DISABLED_TXT }]}
            handle_change={(e: ChangeEvent<HTMLSelectElement>) =>
              filtersHandler(e.target.value, CONSTANTS.STATUS_TXT.toLocaleLowerCase())
            }
            firstOptionText={CONSTANTS.STATUS_TXT}
          />
        </div>
      </div>

      {/* Toggle Icon for Menu on Small Screens */}
      <div>
        <img
          src={isMenuOpen ? crossIcon : menuIcon}
          alt="menu_icon"
          className={`block md:hidden cursor-pointer ml-2 ${isMenuOpen ? "w-8 h-8 bg-gray-200 p-2 rounded-full" : "w-6 h-6"
            }`}
          width={24}
          onClick={toggleMenu}
        />
      </div>
    </div>
  );
};

export default SearchBarAndMenu;
